import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm } from 'react-hook-form'
import { Outlet } from 'react-router-dom'
import * as yup from 'yup'
import { isValidPhoneNumber, isPossiblePhoneNumber } from 'react-phone-number-input';

import { api } from '../../../services/api'
import { cacheAsyncValidation } from '../../../utils/forms'

export type ExpertCreationFormValues = yup.InferType<typeof schema>

const schema = yup.object().shape(
  {
    name: yup
      .string()
      .required('REQUIRED_FIELD')
      .matches(/^[^@#$%*()[\]{}\\|/?><,!+=]+$/, 'INVALID_NAME'),
    email: yup
      .string()
      .email('FIELD_MUST_BE_AN_EMAIL')
      .when('email', {
        is: (email: string) => {
          const pattern = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i
          return pattern.test(email)
        },
        then: yup.string().test(
          'email-validation',
          'EMAIL_ALREADY_IN_USE',
          cacheAsyncValidation(async (email: string) => {
            const emailInLowerCase = email.toLocaleLowerCase()
            const response = await api.get<boolean>(
              `/users/email-available/${emailInLowerCase}`
            )
            return !response.data
          })
        ),
      })
      .required('REQUIRED_FIELD'),
    phone: yup
      .string()
      .required('REQUIRED_FIELD')
      .test('is-valid-phone', 'INVALID_PHONE_NUMBER', (value) => {
        return value ? isValidPhoneNumber(value) && isPossiblePhoneNumber(value) : false;
      }),
    password: yup
      .string()
      .min(8, 'INVALID_PASSWORD')
      .matches(/[a-z]+/, 'INVALID_PASSWORD')
      .matches(/[A-Z]+/, 'INVALID_PASSWORD')
      .matches(/[@$!%*#?&]+/, 'INVALID_PASSWORD')
      .matches(/\d+/, 'INVALID_PASSWORD')
      .required('REQUIRED_FIELD'),
    terms: yup.boolean().oneOf([true]),
  },
  [['email', 'email']]
)

export const StepRegistration = () => {
  const methods = useForm<ExpertCreationFormValues>({
    mode: 'onChange',
    resolver: yupResolver(schema),
  })

  return (
    <div className="flex flex-col justify-center w-full grow">
      <FormProvider {...methods}>
        <Outlet />
      </FormProvider>
    </div>
  )
}
